import OzonAdsCampaigns from '../../../../components/OzonAdsCampaigns';

export default OzonAdsCampaigns;
